import { render, staticRenderFns } from "./SkillSummary.vue?vue&type=template&id=866ec972&"
import script from "./SkillSummary.vue?vue&type=script&lang=js&"
export * from "./SkillSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports